export default __webpack_public_path__ + "static/media/Wheel Unit Spares -2.25431938.jpg";